import { FormGroup } from '@angular/forms';

export abstract class NovoChamadoFormProvider {
  abstract getForm(): FormGroup;
  abstract limparForm(): void;
}
